import { type FC } from "react";
import { Icon } from "../../ui";
import styles from "./AdminDashboardHeader.module.scss";
import Spacing from "../../ui/Spacing";
import { NavLink, useNavigate } from "react-router-dom";
interface AdminDashboardHeaderProps {
  isRightSectionShown: boolean;
}
const AdminDashboardHeader: FC<AdminDashboardHeaderProps> = ({
  isRightSectionShown = true,
}) => {
  const navigate = useNavigate();
  const handleProfile = () => {
    navigate("/dashboard/profile/admin");
  };
  return (
    <header className={styles.sobDashboardHeader}>
      <div className={styles.container}>
        <div className={styles.logo}>
          <img
            src="https://res.cloudinary.com/dv9u0wicr/image/upload/v1745691478/SOB_Images/aceb4t4qoi1beu2gd0oi.png"
            alt=""
            className={styles["logo--img"]}
          />
        </div>
        {isRightSectionShown && (
          <div className={styles.rightSection}>
            <div className={styles.serachContainer}>
              <Icon name="icon-search" size={14} />
              {/* <svg className="icon">
              <use xlink:href="#icon-search"></use>
            </svg> */}

              <input
                id="search_input"
                className={styles.headerSearchInput}
                type="text"
                placeholder="search"
              />
            </div>
            {/* <div className={styles.icon}>Notification</div> */}
            <Spacing>
              <Icon name="icon-notifications" size={20} />
            </Spacing>
            <Spacing>
              <div className={styles.profileWrapper} onClick={handleProfile}>
                <img
                  src="https://res.cloudinary.com/dv9u0wicr/image/upload/v1761494058/bgimage_original_mpnjqa.png"
                  alt=""
                  className={styles.profileImg}
                />
                <NavLink
                  to={"/dashboard/profile/admin"}
                  className={({ isActive }) =>
                    isActive ? styles.activeUserText : styles.userText
                  }
                >
                  Duke
                </NavLink>
                {/* <Text children="Duke" as="label" color="secondary" /> */}
              </div>
            </Spacing>
          </div>
        )}
      </div>
    </header>
  );
};

export default AdminDashboardHeader;
